import { object, string, bool, number } from "yup";
import { Fragments } from "requests";

export const getDropOff = (medCase: Fragments.StoredMedicalCase) => {
  const { dropOff } = medCase.client.patient;
  return {
    admittingConcern: dropOff?.admittingConcern || "",
    evaluateTestAndTreat: dropOff?.evaluateTestAndTreat || false,
    doctor: dropOff?.doctor || null,
    performInitialEvaluation: dropOff?.performInitialEvaluation || false
  };
};

export const getValidationSchema = () =>
  object({
    admittingConcern: string(),
    evaluateTestAndTreat: bool(),
    doctor: number().when("evaluateTestAndTreat", {
      is: true,
      then: number()
        .nullable()
        .required(),
      otherwise: number().nullable()
    }),
    performInitialEvaluation: bool()
  });
